module.exports = __webpack_public_path__ + "dea08c66abd5078c9d9709df8c0f2f26.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-main-1024.webp.png
// module id = 319
// module chunks = 0